import KinvaDocForm from './KinvaDocForm'
export {KinvaDocForm}
export default KinvaDocForm
